import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_filing_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_filing_event_RowClass implements bl_fi_filing_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


